// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1a428281","455":"cfe97ef6","977":"9622c632"}[chunkId] + ".chunk.js";
};